// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__H-nsb","additionalInfo":"AgreementModal_additionalInfo__19V61"};